export const PurchaseOrderCustValidation = (formData) => {
    const errors = {};
   
    if (!formData.cust_FullName || formData.cust_FullName==="") {
        errors.cust_FullName = 'This field is required';
    }
    if (!formData.cust_Address1 || formData.cust_Address1==="") {
        errors.cust_Address1 = 'This field is required';
    }
    if (!formData.cust_Town || formData.cust_Town==="") {
        errors.cust_Town = 'This field is required';
    }
    if (!formData.cust_County || formData.cust_County=="") {
        errors.cust_County = 'This field is required';
    } 
    if (!formData.cust_Telephone || formData.cust_Telephone=="") {
        errors.cust_Telephone = 'This field is required';
    } 
    if (!formData.cust_PostCode || formData.cust_PostCode=="") {
        errors.cust_PostCode = 'This field is required';
    } 
    if (!formData.cust_Country || formData.cust_Country=="0") {
        errors.cust_Country = 'This field is required';
    } 
    return errors;
};
